const CONTEXT_MENU_OPTIONS = ['Copy', 'Cut', 'Paste'];

/** Class other code uses to recognise the menu, e.g. to ignore clicks inside it. */
export const CONTEXT_MENU_CLASS = 'text-editor-dropdown';

// The menu is appended to `document.body`, outside any app root, so it carries its own styles
// instead of relying on a host stylesheet.
const MENU_STYLE: Partial<CSSStyleDeclaration> = {
    position: 'absolute',
    zIndex: '1033',
    overflowY: 'auto',
    boxSizing: 'border-box',
    minWidth: '224px',
    maxWidth: '360px',
    maxHeight: '350px',
    padding: '8px 0',
    borderRadius: '5px',
    background: '#ffffff',
    color: '#354051',
    boxShadow: '0 0 0 1px rgba(3, 16, 38, 0.1), 0 2px 4px -1px rgba(3, 16, 38, 0.1)',
};

const ITEM_STYLE: Partial<CSSStyleDeclaration> = {
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    width: '100%',
    height: '36px',
    margin: '0',
    padding: '0 16px',
    border: 'none',
    borderRadius: '0',
    outline: 'none',
    background: 'none',
    color: '#68707d',
    fontFamily: 'inherit',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    cursor: 'pointer',
};

const ITEM_HOVER_STYLE: Partial<CSSStyleDeclaration> = { background: '#f8f8f9', color: '#354051' };

export const createContextMenu = (onClick: (...args: any[]) => void) => {
    const dropdownElement = document.createElement('div');
    dropdownElement.className = CONTEXT_MENU_CLASS;
    Object.assign(dropdownElement.style, MENU_STYLE);

    CONTEXT_MENU_OPTIONS.forEach((option) => {
        const button = document.createElement('button');
        button.dataset.name = option.toLowerCase();
        button.textContent = option;
        button.onclick = onClick;
        Object.assign(button.style, ITEM_STYLE);
        button.addEventListener('mouseenter', () => Object.assign(button.style, ITEM_HOVER_STYLE));
        button.addEventListener('mouseleave', () => Object.assign(button.style, ITEM_STYLE));

        dropdownElement.appendChild(button);
    });

    return dropdownElement;
};
